import { InputAdornment } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import React from 'react'

import FAIcon from '../../Theme/FAIcon'
import { FA_ICONS } from '../../Theme/font-awesome-icon-constants'
import CustomMuiSelect from '../../Theme/Select'

const SortControls = ({ sort, onSort, sortItems }) => (
  <CustomMuiSelect
    value={sort || 'new'}
    onChange={(event) => {
      onSort(event.target.value)
    }}
    startAdornment={
      <InputAdornment position="end">
        <FAIcon
          iconClassName={FA_ICONS.SORT}
          sx={(theme) => ({
            position: 'absolute',
            color: theme.palette.text.secondary,
            left: 10,
          })}
        />
      </InputAdornment>
    }
    sx={{
      padding: 0,
      backgroundColor: '#ffffff0d',
      '&:hover': {
        backgroundColor: '#ffffff0d',
      },
      '& .MuiSelect-select, .MuiInputBase-input, .MuiOutlinedInput-input': {
        fontFamily: 'Poppins',
        fontWeight: 600,
        // padding: '8px 30px 8px 0 !important',
        background: 'transparent',
      },
      '& .MuiInputAdornment-root, .MuiInputAdornment-positionStart, .MuiInputAdornment-outlined, .MuiInputAdornment-sizeMedium':
        {
          height: '100%',
          margin: 0,
          padding: 1,
        },
    }}
  >
    {sortItems.map(({ title, value }) => (
      <MenuItem
        key={value}
        value={value}
      >
        {title}
      </MenuItem>
    ))}
  </CustomMuiSelect>
)

export default SortControls
